import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { OfficeIconModule } from '@office-ui/icons/icon.component';
import { OfficeModalModule } from '@office-ui/modal/modal.module';

import { ReasonsModalComponent } from './reasons-modal.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		OfficeModalModule,
		OfficeIconModule,
	],
	declarations: [ReasonsModalComponent],
	exports: [ReasonsModalComponent],
})
export class ReasonsModalModule {}
